import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function PaymentFailV6() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const code = searchParams.get("code");
    const message = searchParams.get("message");
    const orderId = searchParams.get("orderId");

    if (
      code === "PAY_PROCESS_CANCELED" ||
      message === "사용자가 결제를 취소하였습니다"
    ) {
      // ignore
    } else {
      if (message) {
        alert(message);
      }
    }

    navigate("/v6-onboarding/payment/1", { replace: true });
  }, [searchParams, navigate]);

  return null;
}
